<template>
  <div class="w-">
    <button
      v-if="!newGroupDisabled"
      v-b-tooltip.hover
      class="btn smallActionButton ml-1"
      placement="bottom"
      title="Sortieren"
      type="button"
      @click="changeSortOrder()"
    >
      <i
        v-if="sorting == 1"
        class="fas fa-sort-alpha-down"
      />
      <i
        v-if="sorting == -1"
        class="fas fa-sort-alpha-up"
      />
      <i
        v-if="sorting == 0"
        class="fas fa-sort"
      />
    </button>

    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="col-12 mt-4"
    />
    <u-loader v-if="isLoading" />
    <v-list v-else>
      <div
        v-for="item in uniqueGroups"
        :key="item.title"
        class="groupControl"
        no-action
      >
        <template @click="editGroup = -1">
          <div
            class="border-bottom p-3 cursor-pointer"
            @click="
              expandedGrouping.indexOf(item) == -1
                ? expandedGrouping.push(item)
                : expandedGrouping.splice(expandedGrouping.indexOf(item), 1)
            "
          >
            <i
              v-if="expandedGrouping.indexOf(item) != -1"
              class="fa fa-chevron-down mr-4 width20"
            />
            <i
              v-else
              class="fas fa-chevron-right mr-4 width20"
              placement="bottom"
            />
            {{ item }}
            <button
              v-if="canUserEdit"
              v-b-modal.deleteGroupingValueCollection
              v-b-tooltip.hover
              class="btn btn-danger smallActionButton float-right ml-1"
              placement="bottom"
              title="Löschen"
              type="button"
              @click="groupingToDelete = item"
              @click.stop="groupingToDelete = item"
            >
              <i class="fas fa-trash-alt" />
            </button>
            <button
              v-if="canUserEdit"
              v-b-modal.editGroupingValueCollection
              v-b-tooltip.hover
              class="btn btn-primary smallActionButton float-right"
              placement="bottom"
              title="Bearbeiten"
              type="button"
              @click="
                editGroupTitle = item;
                setUpGroupEdit();
              "
              @click.stop="groupingToDelete = item"
            >
              <i class="fas fa-edit" />
            </button>
            <!-- Preview Button -->
            <button
              v-if="!canUserEdit"
              v-b-modal.editGroupingValueCollection
              v-b-tooltip.hover
              class="btn smallActionButton float-right"
              placement="bottom"
              title="Vorschau"
              type="button"
              @click="
                editGroupTitle = item;
                setUpGroupEdit();
              "
              @click.stop="groupingToDelete = item"
            >
              <i class="fas fa-eye" />
            </button>
          </div>
          <div v-if="expandedGrouping.indexOf(item) != -1">
            <CriteriaGroupFilterPreview
              :filters="value.filter((group) => group.name == item)[0].filters"
              :operators="operators"
            />
          </div>
        </template>
      </div>
    </v-list>
    <button
      v-if="!newGroupDisabled && canUserEdit"
      v-b-tooltip.hover
      class="btn btn-success float-right smallActionButton mb-4 mr-3"
      placement="bottom"
      title="Neuer Gruppierungswert"
      type="button"
      @click="addNewGroupingValue()"
    >
      <i class="fas fa-plus" />
    </button>

    <b-modal
      id="editGroupingValueCollection"
      ref="editGroupingValueCollection"
      :title="'Gruppierungswert bearbeiten - ' + editGroupTitle"
      class="w-100"
      no-fade
      scrollable
      size="xl"
    >
      <div class="row">
        <div class="col-12">
          <u-help-text
            class="float-right"
            help-id="groupingHelp"
            help-title="Information"
          >
            <p>
              Innerhalb einer Filtergruppe werden die einzelnen Filter mit AND
              (es müssen alle Filter zutreffen) gewertet.
            </p>
            <p>
              Die einzelnen Filtergruppen werden jedoch mit OR (es muss nur eine
              Filtergruppe übereinstimmen) gewertet.
            </p>
          </u-help-text>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label class="font-weight-bold mt-3">Name</label>
        </div>
        <div class="col-10">
          <v-text-field
            v-model="editGroupTitle"
            :disabled="!canUserEdit"
            label="Name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label class="font-weight-bold mt-3">Filtergruppen</label>
        </div>
      </div>

      <v-list>
        <div
          v-for="(
            groupValueItem, groupValueItemIndex
          ) in currentEditGroupCollection"
          :key="groupValueItemIndex"
          class="filterGroup"
        >
          <div
            v-if="groupValueItem.id === editGroup"
            class="w-100"
            style="height: 30px"
          >
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn float-right smallActionButton"
              placement="bottom"
              title="Schliessen"
              type="button"
              @click="editGroup = -1"
            >
              <i class="fas fa-times" />
            </button>
          </div>
          <div
            v-for="(filter, filterIndex) in groupValueItem.filters"
            :key="filterIndex"
            class="w-100"
          >
            <div
              v-if="groupValueItem.id != editGroup"
              class="mb-1 filterGroupHeader"
            >
              <div class="row ml-1">
                <div class="col-3">
                  {{
                    filter.criteriaId != -1 &&
                      $store.state.mindestLohnKonfiguration.Criteria.filter(
                        (criteria) => {
                          return criteria.id == filter.criteriaId;
                        },
                      )[0]
                      ? $store.state.mindestLohnKonfiguration.Criteria.filter(
                        (criteria) => {
                          return criteria.id == filter.criteriaId;
                        },
                      )[0].title
                      : "-"
                  }}
                </div>
                <div
                  class="col-1"
                  style="text-align: center"
                >
                  <v-chip
                    color="darkblue"
                    small
                    style="
                      font-size: 18px;
                      font-weight: 700;
                      padding-bottom: 3px;
                      color: black;
                      background-color: lightgray;
                    "
                  >
                    {{
                      operators.filter((operator) => {
                        return operator.value == filter.operator;
                      })[0].displayName
                    }}
                  </v-chip>
                </div>
                <div class="col-7">
                  {{
                    getCriteriaValue(
                      filter.criteriaId,
                      filter.criteriaListEntryId,
                      filter.value,
                    )
                  }}<br>
                </div>
                <!-- <span class="operator">
                {{ operators.filter(operator => { return operator.value == filter.operator})[0].displayName }}
              </span> -->
              </div>
            </div>
            <div
              v-else
              class="row"
            >
              <criteria-groups-filter
                v-model="groupValueItem.filters[filterIndex]"
                :contract-id="contractId"
                :edition-id="editionId"
                :group-value-item-index="groupValueItemIndex"
                :version-id="versionId"
                class="col-11"
                @validate-value="validateInput"
              />

              <div class="float-right col-1 mt-3">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger smallActionButton"
                  placement="bottom"
                  title="Filter löschen"
                  type="button"
                  @click="deleteFilter(groupValueItem, filterIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="groupValueItem.id == editGroup"
            class="row my-3"
          >
            <div class="col-1">
              <button
                v-if="canUserEdit"
                v-b-tooltip.hover
                class="btn btn-success smallActionButton mt-0"
                onclick
                placement="bottom"
                title="AND/ weitere Bedingung hinzufügen"
                type="button"
                @click="addNewFilter(groupValueItem)"
              >
                <i class="fas fa-plus" />
              </button>
            </div>
            <div class="col-11" />
          </div>

          <div
            v-if="groupValueItem.id != editGroup"
            class="w-100"
            style="height: 35px"
          >
            <button
              v-if="canUserEdit"
              v-b-modal.confirmDeleteFilterGroup
              v-b-tooltip.hover
              class="btn btn-danger float-right smallActionButton"
              placement="bottom"
              title="Filtergruppe löschen"
              type="button"
              @click="
                filterGroupToDeleteIndex = groupValueItem.id;
                setFocusToConfirmButton();
              "
            >
              <i class="fas fa-trash-alt" />
            </button>
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-primary mr-1 float-right smallActionButton"
              onclick
              placement="bottom"
              title="Filtergruppe bearbeiten"
              type="button"
              @click="editGroup = groupValueItem.id"
            >
              <i class="fas fa-edit" />
            </button>
          </div>
        </div>
      </v-list>

      <u-error-handling
        v-if="modalErrorObject"
        :error-object="modalErrorObject"
        class="col-12 mt-4"
      />
      <b-alert
        v-if="inputErrors.length"
        show
        variant="danger"
      >
        <p
          v-for="(inputError, inputErrorIndex) in inputErrors"
          :key="inputErrorIndex"
        >
          {{ inputError }}
        </p>
      </b-alert>

      <template #modal-footer>
        <div
          class="w-100"
          style="height: 40px"
        >
          <button
            v-if="canUserEdit"
            v-b-tooltip.hover
            :disabled="inputErrors.length != 0"
            class="btn btn-success mr-2"
            onclick
            placement="bottom"
            title="Änderungen an Gruppierwert speichern."
            type="button"
            @click="acceptChanges()"
          >
            Speichern
          </button>

          <button
            v-if="canUserEdit"
            v-b-tooltip.hover
            class="btn btn-danger mr-2"
            onclick
            placement="bottom"
            title="Die Einstellungen dieses Gruppierwertes wird zurückgesetzt"
            type="button"
            @click="resetGroupAndCloseModal()"
          >
            Abbrechen
          </button>

          <button
            v-if="canUserEdit"
            v-b-tooltip.hover
            class="btn btn-success mr-2 float-right actionButton"
            onclick
            placement="bottom"
            title="OR/ neue Filtergruppe hinzufügen"
            type="button"
            @click="addNewFilterGroup()"
          >
            <i class="fas fa-plus" />
          </button>
          <button
            v-if="canUserEdit"
            v-b-modal.addLocalisedOrValues
            v-b-tooltip.hover
            class="btn btn-success mr-2 float-right actionButton"
            onclick
            placement="bottom"
            title="Ortsbaum mit Mehrfachauswahl hinzufügen"
            type="button"
          >
            <i class="fas fa-map-marker" />
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="confirmDeleteFilterGroup"
      ref="confirmDeleteFilterGroup"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Filtergruppe löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diese Filtergruppe löschen möchten?
      </div>
      <b-button
        id="autoFocusButton"
        ref="autoFocusButton"
        variant="success"
        @click="deleteFilterGroup()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('confirmDeleteFilterGroup')"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      id="deleteGroupingValueCollection"
      ref="deleteGroupingValueCollection"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Gruppierungswert löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie dieser Gruppierungswert und alle darin
        enthaltene Filter löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="
          hideModal('deleteGroupingValueCollection');
          deleteGrouping();
        "
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteGroupingValueCollection')"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      id="addLocalisedOrValues"
      ref="addLocalisedOrValues"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      size="lg"
      title="Lokalisierte Werte mit OR hinzufügen"
    >
      <div class="d-block mb-4">
        Fügen sie neue Lokalisierte Filter hinzu, die mit OR verknüpft sind.
        Dadurch werden neue Filtergruppen erstellt. Die Änderungen müssen dann
        noch mit dem Button 'Speichern' bestätigt werden. Die Änderungen können
        auch mit dem Button 'Abbrechen' verworfen werden.
      </div>
      <criteria-groups-filter
        v-model="localisedOrCandidates"
        :contract-id="contractId"
        :edition-id="editionId"
        :group-value-item-index="0"
        :limit-tree-selection-by-operator="false"
        :version-id="versionId"
        class="col-11"
        @validate-value="validateInput"
      />

      <b-button
        variant="success"
        @click="addNewMultiLocationTree"
      >
        Hinzufügen
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('addLocalisedOrValues')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  DeleteGroupingValue,
  EditGroupingValues,
} from "@/services/minimum.wage.services/groupings.minimum.wages.js";
import { GetDisplayValueOfPath } from "@/helpers/PlzHelper.js";
import CriteriaGroupsFilter from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsFilter.vue";
import CriteriaGroupFilterPreview from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupFilterPreview.vue";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    CriteriaGroupsFilter,
    CriteriaGroupFilterPreview,
  },
  mixins: [MinimumWageMixin],
  props: {
    value: {
      type: Array,
      required: true,
    },
    groupId: {
      type: Number,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      sorting: 0,
      uniqueGroups: [],
      expandedGrouping: [],
      errorObject: null,
      modalErrorObject: null,
      inputErrors: [],
      currentValueItems: null,
      currentFilterType: null,
      currentChangedValue: null,
      isLoading: false,
      editGroup: -1,
      newGroupDisabled: false,
      originalGroupingsTitle: "",
      groupingToDelete: null,
      editGroupTitle: null,
      localisedOrCandidates: {},
      currentEditGroupCollection: [],
      filterGroupToDeleteIndex: -1,
      originalData: [],
      enableDebug: false,
      operators: [
        { value: 1, name: "Equals", displayName: "=" },
        { value: 2, name: "LessThanOrEqual", displayName: "<=" },
        { value: 3, name: "GreaterThanOrEqual", displayName: ">=" },
        { value: 4, name: "NotEqual", displayName: "!=" },
      ],
    };
  },
  created() {
    this.uniqueGroups = [];
    this.inputErrors = [];
    this.errorObject = null;

    this.originalData = this.setUpOriginalData();

    this.reloadUniqueGroups();
  },
  methods: {
    setUpOriginalData() {
      const newValue = [];
      this.value.forEach((group) => {
        group.name = JSON.parse(JSON.stringify(group.name));

        newValue.push(group);
      });

      if (newValue.length == this.value.length) {
        return newValue;
      }
    },
    changeSortOrder() {
      switch (this.sorting) {
        case -1:
          this.sorting = 0;
          this.reloadUniqueGroups();
          break;
        case 0:
          this.sorting = 1;
          this.reloadUniqueGroups();
          break;
        case 1:
          this.sorting = -1;
          this.reloadUniqueGroups();
          break;

        default:
          break;
      }
    },
    getCriteriaValue(criteriaId, criteriaListEntryId, currentValue) {
      var criteria = this.$store.state.mindestLohnKonfiguration.Criteria.filter(
        (criteria) => {
          return criteria.id == criteriaId;
        },
      );

      if (!criteria || criteria.length == 0) {
        return currentValue;
      }

      var listEntry = criteria[0].listEntries.filter((entry) => {
        return entry.id == criteriaListEntryId;
      });

      if (listEntry.length > 0) {
        return listEntry[0].contents.length == 0
          ? listEntry[0].code
          : listEntry[0].contents[0].text;
      }

      if (criteria[0].criteriaPlzs && criteria[0].criteriaPlzs.length > 0) {
        return GetDisplayValueOfPath(
          currentValue.split(";")[0],
          this.$store.state.mindestLohnKonfiguration.Cities,
        );
      }

      if (currentValue) {
        return currentValue;
      }
    },
    setFocusToConfirmButton() {
      setTimeout(() => {
        this.$refs["autoFocusButton"].focus();
      }, 100);
    },
    deleteGrouping() {
      this.errorObject = null;
      this.isLoading = true;

      DeleteGroupingValue(
        this.contractId,
        this.versionId,
        this.editionId,
        this.groupId,
        this.groupingToDelete,
        () => {
          this.$emit("requireReload");
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
      this.groupingToDelete = null;
    },
    addNewGroupingValue() {
      this.inputErrors = [];
      var newItemGroup = {
        name: "Neuer Wert",
        filters: [],
      };

      newItemGroup.filters.push({
        criteriaStructureId: -1,
        operator: 1,
        value: "",
      });

      var group = [];
      group.push(newItemGroup);

      this.editGroupTitle = "";
      this.currentEditGroupCollection = JSON.parse(JSON.stringify(group));
      this.$refs["editGroupingValueCollection"].show();
    },
    setUpGroupEdit() {
      this.inputErrors = [];
      this.errorObject = null;
      this.originalGroupingsTitle = JSON.parse(
        JSON.stringify(this.editGroupTitle),
      );

      var filteredItems = this.value.filter((sItem) => {
        return sItem.name == this.editGroupTitle;
      });

      let criterias = this.$store.state.mindestLohnKonfiguration.Criteria;
      let plzCriterias = criterias.filter(
        (y) => y.criteriaPlzs && y.criteriaPlzs.length > 0,
      );
      let itemsToProcess = JSON.parse(JSON.stringify(filteredItems));

      itemsToProcess.map((item) => {
        let processedFilters = [];

        item.filters.map((filter) => {
          if (!plzCriterias.some((x) => x.id == filter.criteriaId)) {
            processedFilters.push(filter);
          } else {
            let existingPlzFilter = processedFilters.find(
              (y) =>
                y.criteriaId == filter.criteriaId &&
                y.criteriaListEntryId == filter.criteriaListEntryId &&
                y.criteriaStructureId == filter.criteriaStructureId &&
                y.operator == filter.operator,
            );

            if (existingPlzFilter) {
              existingPlzFilter.value += ";" + filter.value;
            } else {
              processedFilters.push(filter);
            }
          }
        });

        item.filters = processedFilters;
      });

      this.currentEditGroupCollection = JSON.parse(
        JSON.stringify(itemsToProcess),
      );
    },
    hideModal(modalRef) {
      this.inputErrors = [];
      this.errorObject = null;
      this.$refs[modalRef].hide();
    },
    resetGroupAndCloseModal() {
      this.inputErrors = [];
      this.editGroup = -1;
      this.value = JSON.parse(JSON.stringify(this.originalData));
      this.$emit("input", this.value);
      this.hideModal("editGroupingValueCollection");
      this.reloadUniqueGroups();
    },
    addNewFilter(itemToAddFilterTo) {
      itemToAddFilterTo.filters.push({
        criteriaStructureId: -1,
        operator: 1,
        value: "",
      });
    },
    deleteFilter(itemToRemoveFilterFrom, index) {
      itemToRemoveFilterFrom.filters.splice(index, 1);
      if (this.currentChangedValue) {
        this.validateInput(
          this.currentChangedValue,
          this.currentValueItems,
          this.currentFilterType,
        );
      } else {
        this.validateInput(this.value);
      }
      this.$emit("input", this.value);
    },
    deleteFilterGroup() {
      var index = this.currentEditGroupCollection.indexOf(
        this.currentEditGroupCollection.filter((group) => {
          return group.id == this.filterGroupToDeleteIndex;
        })[0],
      );
      this.currentEditGroupCollection.splice(index, 1);
      this.filterGroupToDeleteIndex = -1;
      this.hideModal("confirmDeleteFilterGroup");
    },
    acceptChanges() {
      if (this.inputErrors && this.inputErrors.length > 0) {
        return;
      }

      this.modalErrorObject = null;
      this.isLoading = true;
      this.hideModal("editGroupingValueCollection");

      let criterias = this.$store.state.mindestLohnKonfiguration.Criteria;
      let plzCriterias = criterias.filter(
        (y) => y.criteriaPlzs && y.criteriaPlzs.length > 0,
      );
      let editGroupToSavve = JSON.parse(
        JSON.stringify(this.currentEditGroupCollection),
      );

      editGroupToSavve.map((group) => {
        let groupFilters = [];
        group.filters.map((filter) => {
          if (!plzCriterias.some((x) => x.id == filter.criteriaId)) {
            groupFilters.push(filter);
          } else {
            let paths = filter.value.split(";");

            paths.forEach((path) => {
              groupFilters.push({
                ...filter,
                value: path,
                id: 0,
              });
            });
          }
        });

        group.filters = groupFilters;
      });

      // to get index/order of group: this.uniqueGroups.indexOf(group.name)
      EditGroupingValues(
        this.contractId,
        this.versionId,
        this.editionId,
        this.groupId,
        editGroupToSavve,
        this.editGroupTitle,
        this.originalGroupingsTitle,
        this.getGroupingOrder(this.originalGroupingsTitle),
        () => {
          this.editGroup = -1;
          this.$emit("requireReload");
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.modalErrorObject = error;
          this.$refs["editGroupingValueCollection"].show();
        },
      );
    },
    reloadUniqueGroups() {
      this.uniqueGroups = [];
      this.value.map((group) => {
        if (this.uniqueGroups.indexOf(group.name) == -1) {
          this.uniqueGroups.push(group.name);
        }
      });

      switch (this.sorting) {
        case 1:
          this.uniqueGroups = this.uniqueGroups.sort((a, b) => {
            if (a.toLowerCase() < b.toLowerCase()) {
              return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            }
            return 0;
          });
          break;
        case -1:
          this.uniqueGroups = this.uniqueGroups.sort((a, b) => {
            if (a.toLowerCase() < b.toLowerCase()) {
              return 1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
              return -1;
            }
            return 0;
          });
          break;

        default:
          break;
      }

      this.newGroupDisabled = false;
    },
    addNewFilterGroup() {
      var newItemGroup = {
        name: this.editGroupTitle,
        filters: [],
      };

      newItemGroup.filters.push({
        criteriaStructureId: -1,
        operator: 1,
        value: "",
      });

      this.currentEditGroupCollection.push(newItemGroup);
    },
    addNewMultiLocationTree() {
      let selectedPaths = this.localisedOrCandidates.value.split(";");
      let newFilterGroups = [];
      selectedPaths.map((path) => {
        var newItemGroup = {
          name: this.editGroupTitle,
          filters: [],
        };

        newItemGroup.filters.push({
          ...this.localisedOrCandidates,
          value: path,
        });

        newFilterGroups.push(newItemGroup);
      });

      this.currentEditGroupCollection = [
        ...this.currentEditGroupCollection,
        ...newFilterGroups,
      ];
      this.hideModal("addLocalisedOrValues");
    },
    getGroupingOrder(groupName) {
      var order = this.uniqueGroups.indexOf(groupName);

      if (order == -1) {
        order = this.uniqueGroups.length;
      }

      return order;
    },
    validateInput(changedValue, valueItems, filterType, groupValueItemIndex) {
      this.inputErrors = [];

      let criteriaIdOfValue = changedValue.criteriaId;
      let criteriaOfValue =
        this.$store.state.mindestLohnKonfiguration.Criteria.find(
          (x) => x.id == criteriaIdOfValue,
        );
      if (
        criteriaOfValue.type == 6 ||
        criteriaOfValue.type == 7 ||
        criteriaOfValue.type == 8
      ) {
        this.inputErrors = this.validatePlzFilters(
          changedValue,
          valueItems,
          criteriaOfValue.type,
        );
        return;
      }

      if (this.enableDebug) {
        console.log("%c validateInput", "background: black; color: cyan");
        console.log(changedValue);
        console.log(groupValueItemIndex);
      }
      //Assign values, that no conflicts accure when deleting an item
      this.currentValueItems = valueItems;
      this.currentFilterType = filterType;
      this.currentChangedValue = changedValue;

      let currentGroup = null;
      const diffrentGroup = [];

      if (this.value) {
        const validateHasMultipleFiltergroups = this.hasMultipleFiltergroups();
        if (validateHasMultipleFiltergroups) {
          if (this.enableDebug) {
            console.log(
              "%c Nur eine Filtergruppe",
              "background: black; color: cyan",
            );
          }
          //Validerung wenn es nicht Mehere Filtergruppen hat
          //Validate Groups
          if (this.value.length > 1) {
            this.value.forEach((group) => {
              //Ermittlung der aktuellen Gruppe
              if (
                group.criteriaGroupId ==
                  this.currentEditGroupCollection[0].criteriaGroupId &&
                group.name == this.currentEditGroupCollection[0].name
              ) {
                const findCurrentEditGroupCollection =
                  this.currentEditGroupCollection.find(
                    (searchGroup) => searchGroup.id == group.id,
                  );
                if (this.enableDebug) {
                  console.log("Aktuelle Gruppe überprüfen");
                  console.log(findCurrentEditGroupCollection);
                  console.log(this.currentEditGroupCollection[0]);
                  console.log("-------------------------");
                }
                //Aktuelle Gruppe überprüfen

                if (findCurrentEditGroupCollection) {
                  currentGroup = findCurrentEditGroupCollection;
                  if (findCurrentEditGroupCollection.filters) {
                    this.validateDuplicates(
                      findCurrentEditGroupCollection.filters,
                      changedValue,
                      valueItems,
                      findCurrentEditGroupCollection.name,
                    ).forEach((errorMessage) => {
                      this.inputErrors.push(errorMessage);
                    });
                    this.validateOperatorLogic(
                      findCurrentEditGroupCollection.filters,
                      filterType,
                    ).forEach((errorMessage) => {
                      this.inputErrors.push(errorMessage);
                    });
                  }
                }
              } else {
                if (this.enableDebug) {
                  console.log("Andere Gruppen Überprüfen");
                  console.log(group);
                  console.log("------------------");
                }
                //Andere Gruppen Überprüfen
                diffrentGroup.push(group);
                if (group.filters) {
                  this.validateDuplicates(
                    group.filters,
                    changedValue,
                    valueItems,
                    group.name,
                  ).forEach((errorMessage) => {
                    this.inputErrors.push(errorMessage);
                  });
                  this.validateOperatorLogic(group.filters, filterType).forEach(
                    (errorMessage) => {
                      this.inputErrors.push(errorMessage);
                    },
                  );
                }
              }
            });

            if (
              this.currentEditGroupCollection.length &&
              this.currentEditGroupCollection.length > 1
            ) {
              if (this.enableDebug) {
                console.log("OR Filter vorhanden");
              }
              let currentEditGroupCollectionCounter = 0;
              const newDiffrentGroup = [];

              this.currentEditGroupCollection.forEach(
                (currentGroupValue, index) => {
                  if (this.enableDebug) {
                    console.log(currentGroupValue);
                    console.log(changedValue);
                    console.log("-----------------");
                  }

                  if (
                    !currentGroupValue.id &&
                    currentGroupValue.filters.length > 0
                  ) {
                    //Bei der Erfassung einer neuen Gruppirungswertes
                    if (this.enableDebug) {
                      console.log("Erfassung einer neuen Gruppirungswertes");
                    }

                    if (index == groupValueItemIndex) {
                      currentGroup = currentGroupValue;
                      this.validateDuplicates(
                        currentGroupValue.filters,
                        changedValue,
                        valueItems,
                        currentGroupValue.name,
                      ).forEach((errorMessage) => {
                        this.inputErrors.push(errorMessage);
                      });

                      this.validateOperatorLogic(
                        currentGroupValue.filters,
                        filterType,
                      ).forEach((errorMessage) => {
                        this.inputErrors.push(errorMessage);
                      });
                    } else {
                      newDiffrentGroup.push(currentGroupValue);
                    }

                    // currentGroup = currentGroupValue;
                  }
                  currentEditGroupCollectionCounter++;
                },
              );

              if (
                this.currentEditGroupCollection.length ==
                currentEditGroupCollectionCounter
              ) {
                const validateNewValueDuplicates =
                  this.validateNewValueDuplicates(
                    currentGroup,
                    newDiffrentGroup,
                  );

                if (validateNewValueDuplicates) {
                  this.inputErrors.push(validateNewValueDuplicates);
                }
              }
            } else {
              if (this.enableDebug) {
                console.log("Kein OR Filter vorhanden");
              }
              //Bei der Erfassung einer neuen Gruppirungswertes
              if (
                this.currentEditGroupCollection[0].filters.length > 0 &&
                !this.currentEditGroupCollection[0].id
              ) {
                if (this.enableDebug) {
                  console.log("Erfassung einer neuen Gruppirungswertes");
                }
                currentGroup = this.currentEditGroupCollection[0];

                this.validateDuplicates(
                  this.currentEditGroupCollection[0].filters,
                  changedValue,
                  valueItems,
                  this.currentEditGroupCollection[0].name,
                ).forEach((errorMessage) => {
                  this.inputErrors.push(errorMessage);
                });

                this.validateOperatorLogic(
                  this.currentEditGroupCollection[0].filters,
                  filterType,
                ).forEach((errorMessage) => {
                  this.inputErrors.push(errorMessage);
                });
              }
            }

            // if (filterType == 2) {
            this.validateOperatorLogicWithOtherGroups(
              currentGroup,
              diffrentGroup,
            ).forEach((errorMessage) => {
              this.inputErrors.push(errorMessage);
            });
          } else {
            if (this.enableDebug) {
              console.log("Eine Gruppe oder Keine Gruppen");
            }
            // else, Wenns nur eine Gruppe oder keine Gruppen hatte
            if (this.currentEditGroupCollection[0]) {
              //Bei der Erfassung einer neuen Gruppirungswertes, wenn bereits einer besteht
              if (!this.currentEditGroupCollection[0].id) {
                if (this.value.length >= 1) {
                  this.value.forEach((group) => {
                    diffrentGroup.push(group);

                    if (group.filters) {
                      this.validateDuplicates(
                        group.filters,
                        changedValue,
                        valueItems,
                        group.name,
                      ).forEach((errorMessage) => {
                        this.inputErrors.push(errorMessage);
                      });

                      this.validateOperatorLogic(
                        group.filters,
                        filterType,
                      ).forEach((errorMessage) => {
                        this.inputErrors.push(errorMessage);
                      });
                    }
                  });
                }
              }
              //Wenn bei der Gruppe, zusätzliche Filter hinzugefügt werden, wenn es nur einen Filter hat, ist die Validierung nicht nötig
              if (this.currentEditGroupCollection[0].filters.length > 0) {
                currentGroup = this.currentEditGroupCollection[0];

                if (this.currentEditGroupCollection[0].filters) {
                  this.validateDuplicates(
                    this.currentEditGroupCollection[0].filters,
                    changedValue,
                    valueItems,
                    this.currentEditGroupCollection[0].name,
                  ).forEach((errorMessage) => {
                    this.inputErrors.push(errorMessage);
                  });

                  this.validateOperatorLogic(
                    this.currentEditGroupCollection[0].filters,
                    filterType,
                  ).forEach((errorMessage) => {
                    this.inputErrors.push(errorMessage);
                  });
                  this.validateOperatorLogicWithOtherGroups(
                    currentGroup,
                    diffrentGroup,
                  ).forEach((errorMessage) => {
                    this.inputErrors.push(errorMessage);
                  });
                }
              }
            }
          }
        } else {
          if (this.enableDebug) {
            console.log(
              "%c Mehren Filtergruppen",
              "background: black; color: cyan",
            );
          }
          this.validateMultipleFiltergroups(
            changedValue,
            valueItems,
            filterType,
          );
        }
        if (this.enableDebug) {
          console.log(
            "%c ========================",
            "background: black; color: cyan",
          );
        }
      }
    },
    validateMultipleFiltergroups(changedValue, valueItems, filterType) {
      const filterObject = {};
      let valueCounter = 0;
      let currentGroup = "";
      let currentEditGroupCollection = "";
      if (this.enableDebug) {
        console.log(
          "%c validateMultipleFiltergroups",
          "background: black; color: yellow",
        );
      }

      //Werte am Objekt(filterObject) übertragen
      this.value.forEach((group) => {
        const filters = [];
        let groupFiltersCounter = 0;
        if (this.enableDebug) {
          console.log("ADD GROUP");
        }
        //Ermittlung der aktuellen Gruppe
        if (
          group.criteriaGroupId ==
            this.currentEditGroupCollection[0].criteriaGroupId &&
          group.name == this.currentEditGroupCollection[0].name
        ) {
          let currentGroupeId = "";
          //Aktuelle Gruppe
          if (this.enableDebug) {
            console.log("SAME GROUPE");
            console.log(group);
            console.log(this.currentEditGroupCollection[0]);
            console.log(
              this.currentEditGroupCollection.find(
                (searchGroup) => searchGroup.id == group.id,
              ),
            );
            console.log("------------------");
          }
          const findCurrentEditGroupCollection =
            this.currentEditGroupCollection.find(
              (searchGroup) => searchGroup.id == group.id,
            );

          //Aktuelle Gruppen Filter
          findCurrentEditGroupCollection.filters.forEach((filter) => {
            if (filter.id == changedValue.id) {
              currentGroupeId = group.id;
            }
            filters.push({
              value: filter.value,
              operator: filter.operator,
              criteriaId: filter.criteriaId,
              criteriaListEntryId: filter.criteriaListEntryId,
              criteriaStructureId: filter.criteriaStructureId,
            });

            groupFiltersCounter++;
          });

          if (
            findCurrentEditGroupCollection.filters.length == groupFiltersCounter
          ) {
            //Alle Filter der Aktuellen Gruppe setzen d.h auch or filters
            filterObject[group.id] = {
              id: group.id,
              name: group.name,
              filters: filters,
            };

            if (filterObject[currentGroupeId]) {
              //Die aktuell bearbeitete Gruppe
              currentGroup = filterObject[currentGroupeId];
              currentEditGroupCollection = findCurrentEditGroupCollection;
            }

            valueCounter++;
          }
        } else {
          if (this.enableDebug) {
            console.log("Diffrent GROUPE");
            console.log(group);
            console.log(this.currentEditGroupCollection[0].filters);
            console.log("------------------");
          }
          //Andere Gruppen
          group.filters.forEach((filter) => {
            filters.push({
              value: filter.value,
              operator: filter.operator,
              criteriaId: filter.criteriaId,
              criteriaListEntryId: filter.criteriaListEntryId,
              criteriaStructureId: filter.criteriaStructureId,
            });

            groupFiltersCounter++;
          });

          if (group.filters.length == groupFiltersCounter) {
            filterObject[group.id] = {
              id: group.id,
              name: group.name,
              filters: filters,
            };
            valueCounter++;
          }
        }
        if (this.enableDebug) {
          console.log("=====================");
        }
      });

      if (valueCounter == this.value.length) {
        //Alle Werte wurden erfplgreich am Objek übermittelt
        if (this.enableDebug) {
          console.log("COMPARE");
        }
        for (const key in filterObject) {
          if (this.enableDebug) {
            console.log("Filtering");
            console.log(filterObject[key]);
            console.log(currentGroup);
            console.log("---------------");
          }

          if (currentGroup.id != filterObject[key].id) {
            if (this.enableDebug) {
              console.log("NOT SAME GROUP");
            }
            //Anderer Gruppierungswert überprüfen und nicht die aktuelle überprüfen
            //filters nach dem criteriaId sortieren
            filterObject[key].filters.sort(this.compareCriteriaId);
            currentGroup.filters.sort(this.compareCriteriaId);

            if (
              JSON.stringify(filterObject[key].filters) ==
              JSON.stringify(currentGroup.filters)
            ) {
              if (this.enableDebug) {
                console.log("FOUND DUPLICATS");
                console.log(filterObject[key]);
                console.log(currentGroup);
                console.log("--------------------");
              }
              //Gleiche Filter gefunden
              this.inputErrors.push(
                "Identische Gruppe mit den gleichen Werten gefuden. Indentisch mit der Gruppe: ( " +
                  filterObject[key].name +
                  " )",
              );
            }
          } else {
            if (this.enableDebug) {
              console.log("%c Same groupe ", "background: yellow; color:red");
              console.log(currentEditGroupCollection);
              console.log(changedValue);
              console.log(currentGroup);
            }

            //Aktuelle Gruppierungs Werte überprüfen
            this.validateDuplicates(
              currentEditGroupCollection.filters,
              changedValue,
              valueItems,
              currentEditGroupCollection.name,
            ).forEach((errorMessage) => {
              this.inputErrors.push(errorMessage);
            });
            this.validateOperatorLogic(
              currentEditGroupCollection.filters,
              filterType,
            ).forEach((errorMessage) => {
              this.inputErrors.push(errorMessage);
            });
          }
          if (this.enableDebug) {
            console.log("================================");
          }
        }
      }
      if (this.enableDebug) {
        console.log(
          "%c ========================",
          "background: black; color: yellow",
        );
      }
    },
    compareCriteriaId(a, b) {
      if (a.criteriaId < b.criteriaId) {
        return -1;
      }
      if (a.criteriaId > b.criteriaId) {
        return 1;
      }
      return 0;
    },
    hasMultipleFiltergroups() {
      let currentCriteriaStructureId =
        this.value[0].filters[0].criteriaStructureId;
      let validate = true;
      let counter = 0;
      this.value.forEach((group) => {
        group.filters.forEach((filter) => {
          if (filter.criteriaStructureId != currentCriteriaStructureId) {
            validate = false;
          }
        });
        counter++;
      });

      if (counter == this.value.length || validate == false) {
        return validate;
      }
    },

    validateNewValueDuplicates(currentFilterType, diffrentGroup) {
      let counter = 0;
      let errorMessage = null;
      if (diffrentGroup.length) {
        diffrentGroup.forEach((group) => {
          group.filters.forEach((filter) => {
            currentFilterType.filters.forEach((currentFilter) => {
              if (
                filter.value == currentFilter.value &&
                filter.operator == currentFilter.operator
              ) {
                errorMessage =
                  "Gleiche Rechnungsregeln innerhalb der aktuellen Gruppe gefunden. Der Operator und der Wert wurde mehrmals in der gleichen Kombination verwendet.";
              }
            });
          });
          counter++;
        });
      }
      if (counter == diffrentGroup.length) {
        return errorMessage;
      }
    },

    //Check if same Operation is already used
    validateDuplicates(filters, newValue, valueItems, groupName) {
      if (this.enableDebug) {
        console.log("%c validateDuplicates", "background: black; color: pink");
        console.log(filters);
        console.log(newValue);
      }
      let itemsProcessed = 0;
      let errorMessages = [];
      let negtivOperators = [];
      let positivOperators = [];
      let newValues = []; //New Values dont have id, that make it difficicult to validate
      filters.forEach((filter) => {
        itemsProcessed++;
        //Überprüft, dass nicht der aktuelle kontrolliert wird
        if (filter.id != newValue.id) {
          //Duplikate finden
          if (
            filter.value == newValue.value &&
            filter.operator == newValue.operator
          ) {
            errorMessages.push(
              "Gleiche Rechnungsregeln innerhalb einer Gruppe gefunden. Der Operator und der Wert wurde mehrmals verwendet. Duplikate in der Gruppe (" +
                groupName +
                ") gefunden.",
            );
          }
        } else {
          if (
            filter.value == newValue.value &&
            filter.operator == newValue.operator
          ) {
            newValues.push(filter.value);
          }
        }

        //Negative Duplikate finden
        if (filter.operator == 4) {
          negtivOperators.push({
            operator: 4,
            value: filter.value,
          });
        } else if (filter.operator == 1) {
          positivOperators.push({
            operator: 4,
            value: filter.value,
          });
        }
      });

      if (
        this.value.length > 1 &&
        negtivOperators.length > 0 &&
        errorMessages.length == 0
      ) {
        //Es können nicht alle Werte Negativ sein
        if (valueItems.length == negtivOperators.length) {
          errorMessages.push(
            "Es können nicht alle Werte den gleichen Operator(!=) haben",
          );
        } else if (valueItems.length - 1 == negtivOperators.length) {
          //Validate if same Operation is already used, reversed
          //Fehlenden Wert finden
          let validChecker = true;
          valueItems.forEach((valueItem) => {
            if (
              negtivOperators.find(
                (negtivOperator) => negtivOperator.value == valueItem.code,
              ) == undefined
            ) {
              this.value.forEach((group) => {
                if (
                  group.criteriaGroupId ==
                    this.currentEditGroupCollection[0].criteriaGroupId &&
                  group.name == this.currentEditGroupCollection[0].name
                ) {
                  const findFilter =
                    this.currentEditGroupCollection[0].filters.find(
                      (filter) => filter.value == valueItem.code,
                    );
                  if (findFilter != undefined) {
                    if (findFilter.operator == 4) {
                      validChecker = false;
                    } else {
                      errorMessages.push(
                        this.createNegativErrorMessage(
                          negtivOperators,
                          valueItem.code,
                        ),
                      );
                    }
                  }
                } else {
                  if (
                    group.filters.find(
                      (filter) =>
                        filter.value == valueItem.code && filter.operator != 4,
                    ) != undefined &&
                    validChecker
                  ) {
                    errorMessages.push(
                      this.createNegativErrorMessage(
                        negtivOperators,
                        valueItem.code,
                      ),
                    );
                  }
                }
              });
            }
          });
        }
      }

      if (itemsProcessed === filters.length) {
        if (this.enableDebug) {
          console.log(
            "%c ================================",
            "background: black; color: pink",
          );
        }
        return [...new Set(errorMessages)];
      }
    },
    //Überprüft andere Gruppen mit der Logik der Aktuellen
    validateOperatorLogicWithOtherGroups(currentGroup, diffrentGroups) {
      if (this.enableDebug) {
        console.log(
          "%c validateOperatorLogicWithOtherGroups",
          "background: black; color: lime",
        );
        console.log(currentGroup);
        console.log(diffrentGroups);
      }
      const errorMessages = [];

      if (diffrentGroups.length > 0) {
        diffrentGroups.forEach((diffrentGroup) => {
          let diffrentGroupSmallerValue = null; //Wenn es einen Wert mit dem Operator <= hat, wird dies gespeichert für weitere Validierungen
          let diffrentGroupGreaterValue = null; //Wenn es einen Wert mit dem Operator >= hat, wird dies gespeichert für weitere Validierungen
          const diffrentGroup_NotEqualFilterValues = []; // Wenn es Werte mit dem Operator != hat, werden diese gespeichet, für weitere Validierungen
          const diffrentGroup_EqualFilterValues = [];
          if (diffrentGroup) {
            // Filter einer anderen Gruppen durchgehen
            diffrentGroup.filters.forEach((filter) => {
              // Überprüfung des Operator =, >=, <= in anderen Gruppen , sodass es keine Konflikte gibt
              if (
                filter.operator == 1 ||
                filter.operator == 2 ||
                filter.operator == 3
              ) {
                let currentGroupSmallerValue = null; //Wenn es einen Wert mit dem Operator <= hat, wird dies gespeichert für weitere Validierungen
                let currentGroupGreaterValue = null; //Wenn es einen Wert mit dem Operator >= hat, wird dies gespeichert für weitere Validierungen
                if (currentGroup) {
                  currentGroup.filters.forEach((currentFilter) => {
                    // <= Wert des Operators = kann nicht kleiner sein
                    if (currentFilter.operator == 2) {
                      currentGroupSmallerValue = currentFilter.value;
                    }

                    // >= Wert des Operators = kann nicht grösser sein
                    if (currentFilter.operator == 3) {
                      currentGroupGreaterValue = currentFilter.value;
                    }
                  });
                }

                //Wenn es in der aktuellen Gruppe einen Wert mit dem Operator >= und <= hat, muss überprüft werden, dass es kein wert dazwischen hat mit dem Operator =
                if (currentGroupSmallerValue && currentGroupGreaterValue) {
                  if (currentGroupSmallerValue > currentGroupGreaterValue) {
                    if (
                      filter.value <= currentGroupSmallerValue &&
                      filter.value >= currentGroupGreaterValue
                    ) {
                      errorMessages.push(
                        "Logikfehler: Der Wert( " +
                          this.renderOperatorText(filter.operator) +
                          " " +
                          filter.value +
                          ") der Gruppe (" +
                          diffrentGroup.name +
                          ") kann nicht zwischen den Werten ( >= " +
                          currentGroupGreaterValue +
                          " ) und ( <= " +
                          currentGroupSmallerValue +
                          " ) der aktuellen Gruppe sein.",
                      );
                    }
                  }
                } else if (currentGroupSmallerValue) {
                  if (filter.value <= currentGroupSmallerValue) {
                    errorMessages.push(
                      "Logikfehler: Der Wert( " +
                        this.renderOperatorText(filter.operator) +
                        " " +
                        filter.value +
                        ") der Gruppe (" +
                        diffrentGroup.name +
                        ") kann nicht kleiner sein als der Wert ( <= " +
                        currentGroupSmallerValue +
                        " ) der aktuellen Gruppe sein.",
                    );
                  }
                } else if (currentGroupGreaterValue) {
                  if (filter.value >= currentGroupGreaterValue) {
                    errorMessages.push(
                      "Logikfehler: Der Wert( " +
                        this.renderOperatorText(filter.operator) +
                        " " +
                        filter.value +
                        ") der Gruppe (" +
                        diffrentGroup.name +
                        ") kann nicht grösser sein als der Wert ( >= " +
                        currentGroupGreaterValue +
                        " ) der aktuellen Gruppe sein.",
                    );
                  }
                }
              }
              //= , Überprüfung wenn es in einer anderen Gruppe der Operator = verwendert wird, wird benötigt füt weitere Validierungen
              if (filter.operator == 1) {
                diffrentGroup_EqualFilterValues.push(filter.value);
              }
              //<= , Überprüfung wenn es in einer anderen Gruppe der Operator <= verwendert wird, wird benötigt füt weitere Validierungen
              if (filter.operator == 2) {
                diffrentGroupSmallerValue = filter.value;
              }
              //>= , Überprüfung wenn es in einer anderen Gruppe der Operator >= verwendert wird, wird benötigt füt weitere Validierungen
              if (filter.operator == 3) {
                diffrentGroupGreaterValue = filter.value;
              }
              //!= Überprüfung wenn es in einer anderen Gruppe der Operator != verwendert wird, wird benötigt füt weitere Validierungen
              if (filter.operator == 4) {
                diffrentGroup_NotEqualFilterValues.push(filter.value);
              }
            });
          }
          // Andere Gruppe mit der Logik der Aktuellen Gruppe überprüfen
          if (diffrentGroupSmallerValue && diffrentGroupGreaterValue) {
            if (currentGroup) {
              currentGroup.filters.forEach((currentFilter) => {
                // Wenn der Aktuelle Filter den Operator = hat
                if (
                  currentFilter.operator == 1 ||
                  currentFilter.operator == 2 ||
                  currentFilter.operator == 3
                ) {
                  if (
                    diffrentGroupSmallerValue >= currentFilter.value &&
                    diffrentGroupGreaterValue <= currentFilter.value
                  ) {
                    errorMessages.push(
                      "Logikfehler: Der Wert( " +
                        this.renderOperatorText(currentFilter.operator) +
                        " " +
                        currentFilter.value +
                        ") der aktuellen Gruppe, kann nicht zwischen den Werten ( >= " +
                        diffrentGroupGreaterValue +
                        " ) und ( <= " +
                        diffrentGroupSmallerValue +
                        " ) der Gruppe (" +
                        diffrentGroup.name +
                        ")sein.",
                    );
                  }
                }
              });
            }
          } else if (diffrentGroupSmallerValue) {
            if (currentGroup) {
              currentGroup.filters.forEach((currentFilter) => {
                if (
                  currentFilter.operator == 1 ||
                  currentFilter.operator == 2 ||
                  currentFilter.operator == 3
                ) {
                  if (diffrentGroupSmallerValue) {
                    if (currentFilter.value <= diffrentGroupSmallerValue) {
                      errorMessages.push(
                        "Logikfehler: Der Wert( " +
                          this.renderOperatorText(currentFilter.operator) +
                          " " +
                          currentFilter.value +
                          ") der aktuellen Gruppe kann nicht kleiner sein als der Wert ( <= " +
                          diffrentGroupSmallerValue +
                          " ) der Gruppe (" +
                          diffrentGroup.name +
                          ").",
                      );
                    }
                  }
                }
              });
            }
          } else if (diffrentGroupGreaterValue) {
            if (currentGroup) {
              currentGroup.filters.forEach((currentFilter) => {
                // Wenn der Aktuelle Filter den Operator = hat
                if (
                  currentFilter.operator == 1 ||
                  currentFilter.operator == 2 ||
                  currentFilter.operator == 3
                ) {
                  if (diffrentGroupGreaterValue) {
                    if (currentFilter.value >= diffrentGroupGreaterValue) {
                      errorMessages.push(
                        "Logikfehler: Der Wert( " +
                          this.renderOperatorText(currentFilter.operator) +
                          " " +
                          currentFilter.value +
                          ") der aktuellen Gruppe kann nicht grösser sein als der Wert ( >= " +
                          diffrentGroupGreaterValue +
                          " ) der Gruppe (" +
                          diffrentGroup.name +
                          ").",
                      );
                    }
                  }
                }
              });
            }
          } else if (diffrentGroup_NotEqualFilterValues.length > 0) {
            // Überprüfung wenn es in anderen Gruppen Werte mit den Operator != hat
            if (currentGroup) {
              currentGroup.filters.forEach((currentFilter) => {
                if (currentFilter.value) {
                  // Wenn der Aktuelle Filter den Operator = oder != hat
                  if (
                    currentFilter.operator == 1 ||
                    currentFilter.operator == 4
                  ) {
                    if (
                      !diffrentGroup_NotEqualFilterValues.find(
                        (diffrentGroup_NotEqualFilterValue) =>
                          diffrentGroup_NotEqualFilterValue ==
                          currentFilter.value,
                      )
                    ) {
                      errorMessages.push(
                        "Logikfehler: Der Wert( " +
                          this.renderOperatorText(currentFilter.operator) +
                          " " +
                          ") der aktuellen Gruppe kann nicht mit den Werten ( " +
                          this.renderNotEqualFilterValues(
                            diffrentGroup_NotEqualFilterValues,
                          ) +
                          " ) der Gruppe (" +
                          diffrentGroup.name +
                          ") validiert werden.",
                      );
                    }
                  }
                }
              });
            }
          }
        });
      }
      if (this.enableDebug) {
        console.log(
          "%c =============================",
          "background: black; color: lime",
        );
      }
      return errorMessages;
    },

    //Überprüfen, ob Filter von lokalisierten Kriterien korrekt sind.
    validatePlzFilters(changedValue, valueItems, criteriaType) {
      let errors = [];

      let selectedPlz = [];
      if (changedValue.value) {
        selectedPlz = changedValue.value.split(";");
      }

      let possibleOptions = [];
      if (criteriaType == 6) {
        if (valueItems && valueItems.length > 0) {
          possibleOptions = valueItems[0].children.map((x) => x.value);
        }
      } else if (criteriaType == 7) {
        if (valueItems && valueItems.length > 0) {
          valueItems[0].children.map((x) => {
            possibleOptions.push(...x.children);
          });
        }
      } else if (criteriaType == 8) {
        if (valueItems && valueItems.length > 0) {
          valueItems[0].children.map((x) => {
            x.children.map((y) => {
              possibleOptions.push(...y.children);
            });
          });
        }
      }

      if (
        selectedPlz.length == possibleOptions.length &&
        changedValue.operator == 4
      ) {
        errors.push(
          "Es können nicht alle Werte den gleichen Operator(!=) haben",
        );
      }

      this.currentEditGroupCollection.forEach((entry, entryIndex) => {
        entry.filters.forEach((filter) => {
          this.currentEditGroupCollection.forEach((compare, compareIndex) => {
            if (compareIndex != entryIndex) {
              compare.filters.forEach((compareFilter) => {
                if (
                  filter.operator == compareFilter.operator &&
                  filter.value == compareFilter.value
                ) {
                  errors.push(
                    "Gleiche Rechnungsregeln innerhalb der aktuellen Gruppe gefunden. Der Operator und der Wert wurde mehrmals in der gleichen Kombination verwendet.",
                  );
                }
              });
            }
          });
        });
      });

      return errors;
    },

    renderNotEqualFilterValues(notEqualFilterValues) {
      let errorText = "";
      let arrayIterator = 0;
      notEqualFilterValues.forEach((notEqualFilterValue) => {
        errorText +=
          " != " +
          notEqualFilterValue +
          (arrayIterator + 1 == notEqualFilterValues.length ? "" : ",");
        arrayIterator++;
      });
      if (arrayIterator == notEqualFilterValues.length) {
        return errorText;
      }
    },

    //Gibt den Operator als Textform zurück, für die Ausgabe der Errormessage
    renderOperatorText(filter) {
      switch (filter) {
        case 1:
          return "=";
        case 2:
          return "<=";
        case 3:
          return ">=";
        case 4:
          return "!=";
      }
    },

    //Überprüft nur die Spezifische Gruppe auf Logikfehler
    validateOperatorLogic(filters, filterType) {
      const equalFilters = []; //All Operator with =
      const notEqualFilters = []; //All Operator with <=
      const smallerEqualFilters = []; //All Operator with >=
      const greaterthanEqualFilters = []; //All Operator with !=
      const errorMessages = [];

      //Alle Werte der Gruppe nach dem Operator einfüllen
      filters.forEach((filter) => {
        //Operator 1 : =
        //Operator 2 : <=
        //Operator 3 : >=
        //Operator 4 : !=
        switch (filter.operator) {
          case 1:
            equalFilters.push(filter.value);
            break;
          case 2:
            smallerEqualFilters.push(filter.value);
            break;
          case 3:
            greaterthanEqualFilters.push(filter.value);
            break;
          case 4:
            notEqualFilters.push(filter.value);
            break;
        }
      });

      //Logik überprüfung des Operators =
      equalFilters.forEach((equalFilterValue) => {
        //Der gleiche Wert kann nicht den Operator != und == haben
        if (
          notEqualFilters.find(
            (notEqualFilter) => notEqualFilter == equalFilterValue,
          )
        ) {
          errorMessages.push(
            "Logikfehler: Der gleiche Wert ( " +
              equalFilterValue +
              " ) kann nicht den Opertor ( != ) und ( = ) gleichzeitig haben.",
          );
        }
        if (filterType == 2) {
          //Werte können nicht <= sein, wenn es bereits einen Wert mit dem Operator = hat
          const validSmallerEqualFilters = smallerEqualFilters.find(
            (smallerEqualFilterValue) =>
              smallerEqualFilterValue <= equalFilterValue ||
              smallerEqualFilterValue >= equalFilterValue,
          );
          if (validSmallerEqualFilters) {
            errorMessages.push(
              "Logikfehler: Der Wert ( = " +
                equalFilterValue +
                ") kann nicht kleiner sein, wenn der Operator mit dem Wert ( <= " +
                validSmallerEqualFilters +
                ") besteht.",
            );
          }

          //Werte können nicht >= sein, wenn es bereits einen Wert mit dem Operator = hat
          const validGreaterthanEqualFilters = greaterthanEqualFilters.find(
            (greaterthanEqualFilterValue) =>
              greaterthanEqualFilterValue <= equalFilterValue ||
              greaterthanEqualFilterValue >= equalFilterValue,
          );
          if (validGreaterthanEqualFilters) {
            errorMessages.push(
              "Logikfehler: Der Wert ( = " +
                equalFilterValue +
                " ) kann nicht grösser sein, wenn der Operator mit dem Wert ( >= " +
                validGreaterthanEqualFilters +
                ") besteht.",
            );
          }
        }
      });

      if (filterType == 2) {
        //Bei jeder Gruppirungswertes kann der Operator <= nur einmal vorkommen
        if (smallerEqualFilters.length > 1) {
          errorMessages.push(
            "Logikfehler: Innerhalb eines Gruppirungswertes kann der Operator ( <= ) nicht mehrmals vorkommen",
          );
        } else {
          //Logik Überprüfung des Operators <=
          smallerEqualFilters.forEach((smallerEqualFilterValue) => {
            //Wenn der des Operatos <= grösser ist als der Wert mit dem Operator >=, geht dies Logisch nicht auf
            const validGreaterthanEqualFilter = greaterthanEqualFilters.find(
              (greaterthanEqualValue) =>
                greaterthanEqualValue >= smallerEqualFilterValue,
            );
            if (validGreaterthanEqualFilter) {
              errorMessages.push(
                "Logikfehler : Der Wert ( >= " +
                  validGreaterthanEqualFilter +
                  " ) kann nicht grösser sein als ( <= " +
                  smallerEqualFilterValue +
                  " ).",
              );
            }
            //Ein Wert mit dem Operator = kann nicht grösser sein als der Wert mit dem Operator <=
            const validequalFilter = equalFilters.find(
              (equalFilterValue) => equalFilterValue > smallerEqualFilterValue,
            );
            if (validequalFilter) {
              errorMessages.push(
                "Logikfehler : Der Wert ( = " +
                  validequalFilter +
                  " ) kann nicht grösser sein als ( <= " +
                  smallerEqualFilterValue +
                  " ).",
              );
            }
          });
        }

        //Bei jeder Gruppirungswertes kann der Operator >= nur einmal vorkommen
        if (greaterthanEqualFilters.length > 1) {
          errorMessages.push(
            "Logikfehler: Innerhalb eines Gruppirungswertes kann der Operator  ( >= ) nicht mehrmals vorkommen",
          );
        } else {
          //Logik Überprüfung des Operators >=
          greaterthanEqualFilters.forEach((greaterthanEqualFilterValue) => {
            //Ein Wert mit dem Operator = kann nicht grösser sein als der Wert mit dem Operator >=
            const validequalFilter = equalFilters.find(
              (equalFilterValue) =>
                equalFilterValue < greaterthanEqualFilterValue,
            );
            if (validequalFilter) {
              errorMessages.push(
                "Logikfehler: Der Wert ( = " +
                  validequalFilter +
                  " ) kann nicht kleiner sein als ( >= " +
                  greaterthanEqualFilterValue +
                  " ).",
              );
            }
          });
        }
      }
      return errorMessages;
    },

    createNegativErrorMessage(negtivOperators, valueItemCode) {
      let negativErrorMessageString = "";
      let itemsProcessed = 0;
      negtivOperators.forEach((negtivOperator) => {
        itemsProcessed++;
        negativErrorMessageString =
          negativErrorMessageString + " != (" + negtivOperator.value + "),";
      });
      if (itemsProcessed === negtivOperators.length) {
        return (
          "Logikfehler, " +
          negativErrorMessageString +
          " ergibt das gleiche wie, = (" +
          valueItemCode +
          ") "
        );
      }
    },

    //Validate Structtype
    validateStructType(filters, newValue) {
      let itemsProcessed = 0;
      let validateState = true;

      filters.forEach((filter) => {
        itemsProcessed++;
        if (filter.criteriaStructureId != newValue) {
          validateState = false;
        }
      });
      if (itemsProcessed === filters.length) {
        return validateState;
      }
    },
  },
};
</script>

<style>
.groupControl:hover {
  background-color: rgb(247, 247, 247);
}

.groupControl .v-list__tile {
  height: auto;
}

.groupControl .v-list__tile__title {
  margin: 5px;
}

.modal-dialog-scrollable .modal-body {
  overflow-x: inherit;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.filterGroup {
  padding-bottom: 4px;
  padding-top: 4px;
  border-bottom: 1px solid rgb(168, 168, 168);
  margin-left: -14px;
  margin-right: -15px;
  padding-left: 20px;
  padding-right: 10px;
}

.filterGroup:nth-child(2n) {
  background-color: rgb(248, 248, 248);
}

.operator {
  color: red;
  font-size: large;
  font-weight: 700;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
